import {
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
} from '@angular/common/http';
import { Injectable } from '@angular/core';
import { mapKeys, snakeCase } from 'lodash';
import { Observable } from 'rxjs';

@Injectable()
export class PodcastApiBodyInterceptor implements HttpInterceptor {
  intercept(
    req: HttpRequest<any>,
    handler: HttpHandler,
  ): Observable<HttpEvent<any>> {
    return handler.handle(
      req.clone({
        body: mapKeys(req.body, (_, k) => snakeCase(k)),
      }),
    );
  }
}
